import Loader from "../../../Loader/Index";

// Suggestions of props for component while using the components -------------------------------------
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @typedef {("button" | "submit")} BtnType
 * @typedef {("white" | "black" | "blue")} HoverOption
 * @param {Object} props
 * @param {String} props.btnText - Default string to show
 * @param {BtnType} props.btnType - One of "button" or "submit"
 * @param {OnClickEventHandler} props.handleFunction - What to do when click on button
 * @param {boolean} props.isDisabled
 * @param {String} props.enabledTextColor - Color of text when button is enabled (var only)
 * @param {String?} props.disabledTextColor - Color of text when button is disabled (defaults to enabledTextColor) (var only)
 * @param {String} props.enabledBgColor - Color of bg when button is enabled (var only)
 * @param {String} props.disabledBgColor - Color of bg when button is disabled (var only)
 * @param {String?} props.outLineColor - Color of button outline (border color) (var only)
 * @param {boolean} props.isLoading - Is something relevant loading right now (loading state)
 * @param {HoverOption} props.hoverOption - Hover Option Black or White
 * @param {Object} props.buttonRef - Button ref (optional) eg:- state of button ref
 * @param {boolean} props.fullWidthRequired - Full width required (optional {if false then width will be auto}) eg:- true or false
 * @param {boolean} props.inActiveVariantNeeded - If you want to use inActive variant of button eg:- true or false
 * @param {boolean} props.isLoaderNeeded - If you want loader eg:- true or false
 *
 * @returns {JSX.Element}
 */
const PrimaryButton = ({
  btnText,
  btnType,
  handleFunction,
  isDisabled,
  enabledTextColor,
  disabledTextColor,
  enabledBgColor,
  disabledBgColor,
  isLoading,
  outLineColor,
  hoverOption,
  buttonRef,
  fullWidthRequired,
  inActiveVariantNeeded,
  isLoaderNeeded,
}) => {
  return (
    <button
      ref={buttonRef ? buttonRef : null}
      type={btnType !== null ? btnType : "button"}
      onClick={(e) => {
        if (!isLoading) handleFunction(e);
      }}
      className={`flex z-z-index-base relative justify-center items-center py-padding-button-m px-padding-button-l ${fullWidthRequired ? "w-full" : "w-auto"} h-auto rounded-border-radius-md cursor-${
        isDisabled
          ? `not-allowed ${inActiveVariantNeeded ? "" : "opacity-light-opacity"}`
          : `pointer ${
              isLoading
                ? null
                : hoverOption === "white"
                  ? "global-hover-white"
                  : hoverOption === "blue"
                    ? "global-hover-blue"
                    : hoverOption === "black"
                      ? "global-hover-black"
                      : "global-hover-black"
            }`
      }`}
      style={{
        border: outLineColor ? `var(--border) solid ${outLineColor}` : "",
        backgroundColor:
          isDisabled && disabledBgColor
            ? disabledBgColor?.toString()
            : enabledBgColor?.toString(),
      }}
    >
      {isLoading && isLoaderNeeded ? (
        <div className="absolute flex w-width-full h-height-full justify-center items-center top-top-base">
          <Loader
            height="var(--icon-md)"
            width="var(--icon-md)"
          />
        </div>
      ) : null}

      <div className="flex flex-col items-center">
        <div
          className={`flex justify-center items-center text-font-xs font-semibold wrap-break-word ${isLoading && isLoaderNeeded ? "invisible" : ""}`}
          style={{
            color:
              isDisabled && disabledTextColor
                ? disabledTextColor
                : enabledTextColor,
          }}
        >
          {btnText}
        </div>
      </div>
    </button>
  );
};

export default PrimaryButton;
